/* KH — Minimo 3 lastre (Gruppo 7: 150x300 e 160x320 sotto 12mm) — TAGINA/lastre
   Blocca il checkout se nel carrello ci sono lastre G7 in quantità < 3.
   FAIL-OPEN: in caso di qualsiasi errore lascia procedere il checkout (non blocca vendite). */
(function () {
  var MIN_LASTRE = 3;
  var BTN_SEL = '[name="checkout"], .fx-checkout-btn, #aiCheckoutButton, .Cart__Checkout';

  function num(x){ var n = parseFloat(String(x == null ? '' : x).replace(',', '.').replace(/[^0-9.]/g, '')); return isNaN(n) ? null : n; }

  // È una lastra Gruppo 7? (150x300 sempre; 160x320 solo sotto 12mm)
  function isG7(props) {
    props = props || {};
    var f = String(props['Formato'] || '').toLowerCase().replace(/\s/g, '');
    if (f.indexOf('150x300') !== -1) return true;
    if (f.indexOf('160x320') !== -1) {
      var th = num(props['Spessore']);
      return th != null ? th < 12 : true; // se spessore ignoto, considera G7 (prudente)
    }
    return false;
  }
  function mqPerSlab(props) {
    var m = String(props['Formato'] || '').match(/(\d+(?:[.,]\d+)?)\s*[xX]\s*(\d+(?:[.,]\d+)?)/);
    if (!m) return 4.5;
    return (parseFloat(m[1].replace(',', '.')) * parseFloat(m[2].replace(',', '.'))) / 10000;
  }

  // conta le lastre G7 nel carrello (in pezzi/lastre)
  function countG7(cart) {
    var slabs = 0;
    (cart.items || []).forEach(function (it) {
      var props = it.properties || {};
      if (!isG7(props)) return;
      var mq = num(props['_Total_Mq']);
      var s = (mq != null && mqPerSlab(props)) ? Math.round(mq / mqPerSlab(props)) : (it.quantity || 0);
      slabs += s;
    });
    return slabs;
  }

  document.addEventListener('click', function (e) {
    try {
      var btn = e.target.closest ? e.target.closest(BTN_SEL) : null;
      if (!btn) return;
      if (btn.dataset.khLastreOk === '1') { btn.dataset.khLastreOk = ''; return; } // già validato → passa
      e.preventDefault();
      e.stopImmediatePropagation();
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = countG7(cart);
          if (n > 0 && n < MIN_LASTRE) {
            alert('Le lastre 150x300 e 160x320 si ordinano in minimo ' + MIN_LASTRE + ' pezzi.\nNel carrello ne hai ' + n + '. Aggiungine ancora per procedere.');
          } else {
            btn.dataset.khLastreOk = '1';
            btn.click(); // ri-scatena il checkout
          }
        })
        .catch(function () { btn.dataset.khLastreOk = '1'; btn.click(); }); // FAIL-OPEN
    } catch (err) { /* FAIL-OPEN: non bloccare mai */ }
  }, true);
})();
